var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:_vm.name},[_vm._v("Lottie")])
}
var staticRenderFns = []

export { render, staticRenderFns }